export const SubscriptionPlans = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Back card of the stack, offset to read as "multiple plans" */}
      <path
        d="M6.75 5.25H17.5C18.7426 5.25 19.75 6.25736 19.75 7.5V18.75"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Front card */}
      <rect
        x="3.25"
        y="8.25"
        width="13.5"
        height="12.5"
        rx="2.25"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      {/* Plan tier lines */}
      <path
        d="M6.25 12.25H13.75"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6.25 16.5H10.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
